import type { NsDict } from '../ru';

export const common: NsDict<'common'> = {
  creditsUnit: 'Cr',
  'stage.prep': 'Vorbereitung',
  'stage.round1': 'Runde 1 · Chart und Richtung',
  'stage.round2': 'Runde 2 · Preisskala',
  'stage.round3': 'Runde 3 · Zusammensetzung und Punkte',
  'stage.locked': 'Warten auf den Kerzenschluss',
  'stage.settled': 'Abrechnung',
  'stage.cancelled': 'Abgebrochen',
  'action.ante': 'Ante',
  'action.fold': 'Fold',
  'action.check': 'Check',
  'action.call': 'Call',
  'action.bet': 'Bet',
  'action.raise': 'Raise',
  'action.raiseTo': 'Raise auf',
  'action.allin': 'All-in',
  auto: 'auto',
  loading: 'Wird geladen…',
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
  close: 'Schließen',
  back: '← Zurück',
  forward: 'Weiter →',
  pages: 'Seiten',
  pageOf: '{page} von {pages} · insgesamt {total}',
  never: 'nie',
  justNow: 'gerade eben',
  minutesAgo: 'vor {n} Min.',
  hoursAgo: 'vor {n} Std.',
  daysAgo: 'vor {n} Tg.',
  noData: 'Noch keine Daten.',
  bot: 'Bot',
  botPrefix: 'Bot',
  language: 'Sprache',
  // ── режимы игры (0.8.0) ──
  'stageOpen.round1': 'Runde 1 · Richtung',
  'stageOpen.round2': 'Runde 2 · Punkte',
  'stageOpen.round3': 'Runde 3 · Punkte',
};
